import React, { useState, useEffect } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import "../../common.css";
import "../../investorAcademy.css";
import seminar_img from "../../../../../assets/images/education/button-static.png";
import ChildInvestorAcademyCommon from "../../../../../components/common/InvestorAcademyCommon/ChildInvestorAcademyCommon";

const WarrantSensitivities = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const location = useLocation();
  const history = useHistory();

  return (
    <div id="investor_academy">
      <div className="imgbg" />
      <div className="mainbg"></div>

      <div id="main" className="warrant-sensitivity Common_warrent">
        <div
          id="maintable"
          style={{ display: "table", width: "100%", tableLayout: "fixed" }}
        >
          <div style={{ display: "table-row" }}>
            <div
              id="leftbar"
              className="hidden-xs"
              style={{ display: "table-cell", width: "80px" }}
            />
            <div
              id="maincontainer"
              style={{ display: "table-cell", width: "100%" }}
            >
              <div id="mainnav" className="first_table">
                <table
                  style={{
                    width: "100%",
                    tableLayout: "fixed",
                    borderBottom: "1px solid #353223",
                  }}
                >
                  <tbody>
                    <tr>
                      <td
                        width="20%"
                        style={{ textAlign: "left", visibility: "hidden" }}
                      >
                        <table
                          className="hasprev hidden-xs"
                          style={{
                            width: "100%",
                            height: "100%",
                            tableLayout: "fixed",
                          }}
                        >
                          <tbody>
                            <tr>
                              <td width="33px">
                                <div className="prev left" />
                              </td>
                              <td>
                                <div className="prevlbl left">
                                  <div
                                    className="prevtitle "
                                    style={{ textAlign: "left" }}
                                  />
                                  <div
                                    className="prevname "
                                    style={{ textAlign: "left" }}
                                  >
                                    Exercise Ratio
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td width="60%" style={{ textAlign: "center" }}>
                        <div
                          id="pagetitlediv"
                          style={{
                            width: "365px",
                            height: "100%",
                            borderBottom: "1px solid #FFD843",
                            margin: "auto",
                          }}
                        >
                          <div
                            id="ptitle"
                            style={{
                              fontFamily: "HelveticaNeueThinCond",
                              fontSize: "25px",
                              color: "white",
                              letterSpacing: "1px",
                            }}
                          >
                            Useful Warrant terms
                          </div>
                          <div
                            id="pname"
                            style={{
                              fontFamily: "HelveticaNeueThinCond",
                              fontSize: "30px",
                              color: "#FFD843",
                              letterSpacing: "1px",
                              paddingTop: "5px",
                              paddingBottom: "5px",
                            }}
                          >
                            Warrant Sensitivity
                          </div>
                        </div>
                      </td>
                      <td
                        width="20%"
                        style={{ textAlign: "right", visibility: "hidden" }}
                      >
                        <table
                          className="hasnext  hidden-xs"
                          style={{
                            width: "100%",
                            height: "100%",
                            tableLayout: "fixed",
                          }}
                        >
                          <tbody>
                            <tr>
                              <td>
                                <div className="nextlbl right">
                                  <div
                                    className="nexttitle "
                                    style={{ textAlign: "right" }}
                                  />
                                  <div
                                    className="nextname "
                                    style={{ textAlign: "right" }}
                                  >
                                    Breakeven Price
                                  </div>
                                </div>
                              </td>
                              <td width="33px">
                                <div className="next right" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                id="maincontent"
                style={{
                  marginLeft: "10px",
                  marginRight: "10px",
                  paddingTop: "40px",
                  marginBottom: "60px",
                }}
              >
                <div
                  id="mainscroll"
                  style={{
                    height: "100%",
                    overflowX: "hidden",
                    overflowY: "auto",
                    paddingLeft: "90px",
                    paddingRight: "90px",
                  }}
                >
                  <div id="mainscrollcontent">
                    <meta
                      httpEquiv="Content-Type"
                      content="text/html; charset=UTF-8"
                    />
                    <title>Warrant sensitivity</title>
                    <style
                      dangerouslySetInnerHTML={{
                        __html:
                          "\n/*            .exampleholder .examplebox h3{\n                margin:0;\n                margin-bottom:16px;\n                font-weight: normal;\n            }*/\n/*            .xs exampleholder .examplebox h3,\n            .xss exampleholder .examplebox h3{\n                font-size:18px;\n            }*/\n            .exampleholder .examplebox .col{\n line-height: 1.42857143; \n                float:left;\n                width:50%;\n                min-width:280px;\n                margin:2px 0;\n            }\n            .exampleholder .examplebox .line{\n                clear:both;\n                width:96%;\n                height: 0;\n                padding-top:12px;\n                border-bottom: 2px solid #404040;\n            }\n            .exampleholder .examplebox .col .lbl,\n            .exampleholder .examplebox .col .val{\n                float:left;\n            }\n            .exampleholder .examplebox .col .lbl{\n                width:110px;\n                color:#8F8F8F;\n            }\n            .imgholder img.img01{\n                max-width: 800px; \n            }\n            .imgholder img.img02{\n                max-width: 800px; \n            }\n            .formulabox table{\n                text-align:center;\n            }\n            .formulabox table .first_row td{\n                font-size: 1em;\n            }\n            .formulabox table .second_row td{\n                font-size: 12px;\n            }\n        ",
                      }}
                    />
                    <div className="contentbox">
                      <p>
                        A warrant’s “Sensitivity” is an estimate of how much the
                        underlying price needs to move for a corresponding one
                        tick (or minimum spread) movement in the warrant. We use
                        delta and exercise ratio to calculate the sensitivity of
                        the warrant to the underlying.
                      </p>

                      <div className="exampleholder">
                        <div className="examplebox">
                          <h3 style={{ color: "#fff" }}>Example:</h3>
                          <div className="col">
                            <div className="lbl">Type:</div>
                            <div className="val">Call Warrant</div>
                          </div>
                          <div className="col">
                            <div className="lbl">SW Price:</div>
                            <div className="val">MYR 0.20</div>
                          </div>
                          <div className="col">
                            <div className="lbl">Underlying:</div>
                            <div className="val">Share A</div>
                          </div>
                          <div className="col">
                            <div className="lbl">Exercise Ratio:</div>
                            <div className="val">2:1</div>
                          </div>
                          <div className="col">
                            <div className="lbl">Expiry:</div>
                            <div className="val">01 December</div>
                          </div>
                          {/* <div className="col"><div className="lbl">Expiry:</div><div className="val">1 Dec</div></div> */}
                          <div className="col">
                            <div className="lbl">Delta:</div>
                            <div className="val">100%</div>
                          </div>
                          <div className="line" />
                          {/*<h3 style="margin:0;margin-top:12px;">Delta per SW = 100%/2 = 50%</h3>*/}
                          <table
                            style={{
                              paddingBottom: 0,
                              margin: 0,
                              verticalAlign: "middle",
                              fontSize: "15px",
                            }}
                          >
                            <tbody>
                              <tr>
                                <td>Delta per SW </td>
                                <td>= 100% / 2</td>
                              </tr>
                              <tr>
                                <td />
                                <td>= 50%</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <p>
                        In this example, we are using a call warrant over Share
                        A, the warrant has a price of 20 cents.{" "}
                      </p>
                      <p>
                        The exercise ratio is 2 and the warrant expires on 1
                        December. The delta is 100%, which means it has a 100%
                        chance of being in- the-money (ITM) when it expires.
                      </p>
                      <h2>Calculating the warrant sensitivity</h2>
                      <p>
                        To calculate how many ticks in the underlying is
                        required for a one tick move in the warrant (i.e.
                        minimum tick of MYR 0.005 for warrants priced below MYR
                        1.00), you first need to know the delta per warrant.
                      </p>
                      <p>
                        You would recall from the previous chapter on “Delta”
                        that the delta formula is as below:{" "}
                      </p>
                      <h2>DELTA FORMULA</h2>
                      <div className="formulaholder">
                        <div className="formulabox">
                          <div className="leqt">
                            <table>
                              <tbody>
                                <tr>
                                  <td
                                    className="hltxt"
                                    style={{ height: "39px" }}
                                  >Delta &nbsp;= &nbsp; </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="reqt">
                            <table className="fraction">
                              <tbody>
                                <tr>
                                  <td>Change in Warrant price</td>
                                </tr>
                                <tr>
                                  <td className="upper_line">
                                    Change in Underlying Warrant price
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <p>
                        To calculate the “Delta per warrant”, you divide 100% by
                        the exercise ratio of 2, to get a figure of 50% or 0.50.
                        Now that you have the delta per warrant, you can
                        calculate the Sensitivity, i.e. how much the underlying
                        will move for a 1 tick move (MYR0.005) in the warrant.
                      </p>
                      <h2>SENSITIVITY FORMULA</h2>
                      <div className="formulaholder">
                        <div className="formulabox">
                          <div className="leqt">
                            <table>
                              <tbody>
                                <tr>
                                  <td
                                    className="hltxt"
                                    style={{ height: "39px" }}
                                  >
                                    Change in Underlying &nbsp;=&nbsp;
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="reqt">
                            <table className="fraction">
                              <tbody>
                                <tr>
                                  <td>Change in Warrant price</td>
                                </tr>
                                <tr>
                                  <td className="upper_line">
                                    Delta per warrant
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      <p>
                        Simply divide the change in warrant price of MYR 0.005
                        by the delta per warrant of 50%, and you would arrive at
                        a sensitivity of MYR 0.01. Meaning that each time the
                        share price moves MYR 0.01, the warrant price will move
                        one tick, or MYR 0.005.{" "}
                      </p>
                      <p>See illustration for the calculation below. </p>
                      <div className="formulaholder">
                        <div className="formulabox">
                          <div className="leqt">
                            <table>
                              <tbody>
                                <tr>
                                  <td
                                    className="hltxt"
                                    style={{ height: "39px" }}
                                  >
                                    Change in Underlying&nbsp;=&nbsp;
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="reqt">
                            <table className="fraction">
                              <tbody>
                                <tr>
                                  <td>MYR 0.005</td>
                                </tr>
                                <tr>
                                  <td className="upper_line">50%</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="leqt">
                            <table>
                              <tbody>
                                <tr>
                                  <td style={{ height: "39px" }}>
                                    &nbsp; =&nbsp;MYR 0.01
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <p>
                        With a sensitivity of MYR 0.01, which is 1 tick in Share
                        A (as with all Malaysian stocks above MYR 1.00), we say
                        that this warrant moves “tick for tick”, which means its
                        price will move one tick for every tick in the
                        underlying share.
                      </p>
                      <p>
                        For index warrants, the same calculation can be used.
                      </p>
                      <div className="exampleholder">
                        <div className="examplebox">
                          <h3 style={{ color: "#fff" }}>Example:</h3>
                          <div className="col">
                            <div className="lbl">Type:</div>
                            <div className="val">Call Warrant</div>
                          </div>
                          <div className="col">
                            <div className="lbl">SW Price:</div>
                            <div className="val">MYR 0.20</div>
                          </div>
                          <div className="col">
                            <div className="lbl">Underlying:</div>
                            <div className="val">HSI</div>
                          </div>
                          <div className="col">
                            <div className="lbl">Exercise Ratio:</div>
                            <div className="val">900:1</div>
                          </div>
                          <div className="col">
                            <div className="lbl">Expiry:</div>
                            <div className="val">01 December</div>
                          </div>
                          <div className="col">
                            <div className="lbl">Delta:</div>
                            <div className="val">90%</div>
                          </div>
                          <div className="col">
                            <div className="lbl">HKD/MYR FX rate:</div>
                            <div className="val">0.56</div>
                          </div>
                          <div className="line" />
                          <table
                            style={{
                              paddingBottom: 0,
                              margin: 0,
                              verticalAlign: "middle",
                              fontSize: "15px",
                            }}
                          >
                            <tbody>
                              <tr>
                                <td>Delta per SW </td>
                                <td>= 90% / 900</td>
                              </tr>
                              <tr>
                                <td />
                                <td>= 0.1%</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <p>
                        In the case of the above Hang Seng Index (HSI) warrant,
                        the delta per warrant can be calculated by dividing the
                        delta of 90% by the exercise ratio of 900, which gives
                        0.1% or 0.001. Hence, for the warrant to move 1 tick
                        (MYR 0.005*), the HSI will have to move: MYR 0.005
                        divided by the Delta per SW of 0.1%, and thereafter
                        converted to HKD, as the HSI is based on HKD whereas the
                        warrants are priced in MYR.
                      </p>
                      <p>See illustration for the calculation below.</p>
                      <div className="formulaholder">
                        <div className="formulabox">
                          <div className="leqt">
                            <table>
                              <tbody>
                                <tr>
                                  <td
                                    className="hltxt"
                                    style={{ height: "39px" }}
                                  >
                                    Change in Underlying &nbsp;=&nbsp;
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="reqt">
                            <table className="fraction">
                              <tbody>
                                <tr>
                                  <td>MYR 0.005</td>
                                </tr>
                                <tr>
                                  <td className="upper_line">0.1%</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="reqt">
                            <table>
                              <tbody>
                                <tr>
                                  <td style={{ height: "39px" }}>x</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="reqt">
                            <table className="fraction">
                              <tbody>
                                <tr>
                                  <td>1</td>
                                </tr>
                                <tr>
                                  <td className="upper_line">0.56</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="leqt">
                            <table>
                              <tbody>
                                <tr>
                                  <td style={{ height: "39px" }}>
                                    &nbsp; = &nbsp;8.9 points
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <p>
                        <em>
                          Notes:
                          <br />
                          If the underlying share or index is not denominated in
                          MYR, you must factor in the relevant exchange rate
                          into your calculation.
                          <br />
                          *1 tick equals to RM0.005 for warrants priced below
                          RM1.00, and equals to RM0.010 for warrants priced
                          between RM1.00 to RM9.99
                        </em>
                      </p>
                      <div className="tipholder">
                        <div className="tipbox">
                          <h2>
                            Helpful Tips on how to use Warrant Sensitivity
                          </h2>
                          <ul>
                            <li>
                              <p>
                                Always remember to take into account the
                                exercise ratio when looking at sensitivity.
                              </p>
                            </li>
                            <li>
                              <p>
                                Warrant sensitivity is primarily used by short
                                term day traders and investors interested in the
                                small/short term movements in a warrant. For all
                                other investors, Delta or Effective Gearing are
                                likely to be more useful.
                              </p>
                            </li>
                            <li>
                              <p>
                                You can view the warrant sensitivity for each
                                warrant via the{" "}
                                <Link target="_blank" to="/tools/warrantterms">
                                  Warrants Terms Page.
                                </Link>
                              </p>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="rightbar"
                  className="hidden-xs"
                  style={{ display: "table-cell", width: "80px" }}
                ></div>
              </div>
            </div>
            <div
              id="rightbar"
              className="hidden-xs"
              style={{ display: "table-cell", width: "80px" }}
            ></div>
          </div>
        </div>
      </div>

      <div
        id="bottom"
        style={{
          position: "fixed",
          width: "100%",
          bottom: "0px",
          height: "40px",
          backgroundColor: "#101010",
          zIndex: 10000,
        }}
      >
        <div
          className="hidden-xs hidden-xxs"
          style={{
            display: "table",
            width: "100%",
            textAlign: "center",
            color: "#8F8F8F",
            fontSize: "11px",
            lineHeight: "40px",
          }}
        >
          <div className="copyright_sec">
            Copyright (c) 2016 Macquarie Group Limited ABN 94 122 169 279. All
            rights reserved.
          </div>
        </div>
        <div
          style={{
            position: "absolute",
            width: "46%",
            height: "35px",
            right: "10px",
            bottom: "5px",
          }}
        >
          <table
            className="hasnext"
            style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
          >
            <tbody>
              <tr>
                <td>
                  <div className="nextlbl right">
                    <div
                      className="nextname "
                      style={{ textAlign: "right", fontSize: "15px" }}
                    >
                      <Link to="/edu/useful-warrant-terms/break-even-price">
                        Breakeven Price
                      </Link>
                    </div>
                  </div>
                </td>
                <td width="33px">
                  <Link to="/edu/useful-warrant-terms/break-even-price">
                    <div className="next right" />
                  </Link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          style={{
            position: "absolute",
            width: "46%",
            height: "35px",
            left: "10px",
            bottom: "5px",
          }}
        >
          <table
            className="hasprev"
            style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
          >
            <tbody>
              <tr>
                <td width="33px">
                  <Link to="/edu/useful-warrant-terms/excercise-ratio">
                    <div className="prev left" />
                  </Link>
                </td>
                <td>
                  <div className="prevlbl left">
                    <div
                      className="prevname "
                      style={{ textAlign: "left", fontSize: "15px" }}
                    >
                      <Link to="/edu/useful-warrant-terms/excercise-ratio">
                        Exercise Ratio
                      </Link>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div id="dotbar" className="hidden-sm hidden-xs">
        <ChildInvestorAcademyCommon Location={location} Hist={history} />
      </div>
    </div>
  );
};
export default WarrantSensitivities;
